export const ACTION = {
  AUTHOR_EVALUABLE_GET: 'AUTHOR_EVALUABLE_GET',
  AUTHOR_EVALUABLE_PUT: 'AUTHOR_EVALUABLE_PUT',
  AUTHOR_EVALUABLE_SET: 'AUTHOR_EVALUABLE_SET',
  AUTHOR_EVALUABLE_DELETE: 'AUTHOR_EVALUABLE_DELETE',

  AUTHOR_EVALUABLE_GET_RESPONSE: 'AUTHOR_EVALUABLE_GET_RESPONSE',
  AUTHOR_EVALUABLE_GET_ERROR: 'AUTHOR_EVALUABLE_GET_ERROR',
  AUTHOR_EVALUABLE_MUTATE_RESPONSE: 'AUTHOR_EVALUABLE_MUTATE_RESPONSE',
  AUTHOR_EVALUABLE_MUTATE_ERROR: 'AUTHOR_EVALUABLE_MUTATE_ERROR',
};

export const RTM_OPERATION = {
  AUTHOR_EVALUABLE_DELETE: 'author.evaluable.delete',
  AUTHOR_EVALUABLE_GET: 'author.evaluable.get',
  AUTHOR_EVALUABLE_SET: 'author.evaluable.set',
};

export const RTM_REPLY = {
  AUTHOR_EVALUABLE_DELETE_OK: 'author.evaluable.delete.ok',
  AUTHOR_EVALUABLE_DELETE_ERROR: 'author.evaluable.delete.error',
  AUTHOR_EVALUABLE_GET_OK: 'author.evaluable.get.ok',
  AUTHOR_EVALUABLE_GET_ERROR: 'author.evaluable.get.error',
  AUTHOR_EVALUABLE_SET_OK: 'author.evaluable.set.ok',
  AUTHOR_EVALUABLE_SET_ERROR: 'author.evaluable.set.error',
};

